import { RemoteDepositLocation } from '@treasury/domain/remote-deposit-capture';
import { RemoteDepositItemVm } from '../view-models';

export enum RemoteDepositEvent {
    SubmitDeposit = 'submit-deposit',
    DeleteDeposit = 'delete-deposit',
    AddCheck = 'add-check',
    RemoveCheck = 'remove-check',
    FinishedDeposit = 'finished-deposit',
    NewDeposit = 'new-deposit',
    ProceedToReview = 'proceed-to-review',
    ProceedToCreate = 'proceed-to-create',
    ChangeCheckSide = 'change-check-side',
    LocationSelected = 'location-selected',
    CancelCapture = 'cancel-capture',
}

export type SubmitDepositPayload = void;
export type SubmitDepositEvent = CustomEvent<SubmitDepositPayload>;

export type DeleteDepositPayload = void;
export type DeleteDepositEvent = CustomEvent<DeleteDepositPayload>;

export type AddCheckPayload = void;
export type AddCheckEvent = CustomEvent<AddCheckPayload>;

export type RemoveCheckPayload = RemoteDepositItemVm;
export type RemoveCheckEvent = CustomEvent<RemoveCheckPayload>;

export type FinishedDepositPayload = void;
export type FinishedDepositEvent = CustomEvent<FinishedDepositPayload>;

export type NewDepositPayload = void;
export type NewDepositEvent = CustomEvent<NewDepositPayload>;

export type ProceedToReviewPayload = RemoteDepositItemVm;
export type ProceedToReviewEvent = CustomEvent<ProceedToReviewPayload>;

export type ProceedToCreatePayload = {
    frontImage?: string;
    rearImage?: string;
};
export type ProceedToCreateEvent = CustomEvent<ProceedToCreatePayload>;

export type ChangeCheckSidePayload = void;
export type ChangeCheckSideEvent = CustomEvent<ChangeCheckSidePayload>;

export type LocationSelectedPayload = RemoteDepositLocation;
export type LocationSelectedEvent = CustomEvent<LocationSelectedPayload>;

export type CancelCapturePayload = void;
export type CancelCaptureEvent = CustomEvent<CancelCapturePayload>;
